import React from 'react';
import { CheckSquare } from 'lucide-react';

/**
 * Компонент с дополнительными параметрами для калькулятора рентабельности
 */
const AdditionalParametersSection = ({ 
  formData, 
  handleInputChange, 
  errors 
}) => {
  return (
    <div className="mb-6 bg-gray-50 dark:bg-gray-800/30 p-4 rounded-lg border border-gray-200 dark:border-gray-700">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <CheckSquare className="w-5 h-5 mr-2 text-emerald-500" />
        Дополнительные параметры
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Детализация расходов */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeDetailedCosts"
              checked={formData.includeDetailedCosts}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Детализировать структуру расходов
            </span>
          </label>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400 ml-6">
            Разбивка себестоимости и операционных расходов по категориям
          </p>
        </div>

        {/* Дополнительные финансовые показатели */}
        <div className="col-span-full">
          <label className="inline-flex items-center">
            <input
              type="checkbox"
              name="includeAdditionalMetrics"
              checked={formData.includeAdditionalMetrics}
              onChange={handleInputChange}
              className="form-checkbox"
            />
            <span className="ml-2 text-sm text-gray-700 dark:text-gray-300">
              Включить расширенную аналитику
            </span>
          </label>
          <p className="mt-1 text-xs text-gray-500 dark:text-gray-400 ml-6">
            Расчет дополнительных финансовых показателей (EBITDA, ROA, ROE и др.)
          </p>
        </div>
      </div>

      {/* Подсказка о средних показателях */}
      <div className="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
        <p className="text-xs text-gray-600 dark:text-gray-400">
          В результатах расчета будет представлено сравнение ваших показателей со средними по отрасли,
          а также рекомендации по улучшению рентабельности бизнеса.
        </p>
      </div>
    </div>
  );
};

export default AdditionalParametersSection;